import { ObjectUtils } from '@mm/utils';
import { createSelector } from 'reselect';
import { SessionObject } from '../interfaces/session';
import { UserRole } from '../model/CompanyUsersModel';
import { StoreState } from '../store-interfaces';
import { activeFacebookPageSelector } from './facebookPageSelector';

const selectSession = (state: StoreState) => state.session;

export const selectSessionSelector = createSelector(
  [selectSession],
  item => item.session,
);

// user might be registered with mocked FB page
export const hasConnectedRealFacebookPageSelector = createSelector(
  [selectSessionSelector, activeFacebookPageSelector],
  (session, facebookPage) => !!facebookPage?.realFacebookPage,
);

export const selectCompanyUsers = (state: StoreState) =>
  state.companyUsers.entities;

export const selectCurrentUserId = createSelector(
  [selectSessionSelector],
  (session: SessionObject) => session?.id,
);

export const selectCompanyOwner = (state: StoreState) =>
  state.companyUsers.entities.find(user => user.role === UserRole.Owner);

export const selectSessionAuthenticated = createSelector(
  [selectSessionSelector],
  (session: SessionObject) => !!session?.id,
);

export const selectCurrentUserBetaUiEnabled = createSelector(
  [selectSessionSelector],
  () => true,
);

export const selectCurrentUser = createSelector(
  [selectCurrentUserId, selectCompanyUsers],
  (userId, companyUsers) => companyUsers.find(u => u.id === userId),
);

// Sys Admin or CS Admin
export const selectCurrentUserIsAdmin = createSelector(
  [selectCurrentUser],
  currentUser => Boolean(currentUser?.csAdmin || currentUser?.admin),
);
export const isFacebookConnectedSelector = createSelector(
  [selectCurrentUser, selectSessionSelector],
  (user, session) =>
    Boolean(user?.facebookTokenExists || session.facebookTokenExists),
);

export const oneTimeAlertsSeenSelector = createSelector(
  [selectSessionSelector],
  session =>
    ObjectUtils.deepSnakeKeys(session.userAttributes.oneTimeAlertsSeen || {}),
);

export const isFacebookUserSelector = createSelector(
  [hasConnectedRealFacebookPageSelector, isFacebookConnectedSelector],
  (...flags) => flags.some(Boolean),
);

export const selectInviteToken = createSelector(
  [selectSession],
  item => item.inviteToken,
);

export const instachampEnrollmentsSelector = createSelector(
  [selectSessionSelector],
  session => session.userAttributes.instachampEnrollments || {},
);

export const papAffiliateSelector = createSelector(
  [selectSession],
  session => session.papAffiliate,
);

export const selectIsShopifyUser = createSelector(
  [selectSession],
  session => session?.session?.shops?.length,
);
